module.exports = __webpack_public_path__ + "img/duck1.175bea0b.png";